import { apiClient } from '../api-client'

export interface Team {
  id: string
  organization_id?: string | null
  name: string
  description?: string | null
  lead_id?: string | null
  lead_name?: string | null
  is_active: boolean
  settings: Record<string, any>
  created_by?: string | null
  created_at?: string
  updated_at?: string
  member_count?: number
}

export interface TeamListResponse {
  teams: Team[]
  total: number
}

export interface TeamPayload {
  name: string
  description?: string
  lead_id?: string | null
  is_active?: boolean
  settings?: Record<string, any>
}

export interface TeamMember {
  user_id: string
  name?: string | null
  email?: string | null
}

export const teamsApi = {
  getTeams: (params?: { q?: string; is_active?: boolean }): Promise<TeamListResponse> =>
    apiClient.get('/teams', { params }),

  getTeam: (teamId: string): Promise<Team> =>
    apiClient.get(`/teams/${teamId}`),

  createTeam: (data: TeamPayload): Promise<Team> =>
    apiClient.post('/teams', data),

  updateTeam: (teamId: string, data: Partial<TeamPayload>): Promise<Team> =>
    apiClient.put(`/teams/${teamId}`, data),

  getTeamMembers: (teamId: string): Promise<TeamMember[]> =>
    apiClient.get(`/teams/${teamId}/members`),

  addTeamMember: (teamId: string, userId: string): Promise<Team> =>
    apiClient.post(`/teams/${teamId}/members`, { user_id: userId }),

  removeTeamMember: (teamId: string, userId: string): Promise<Team> =>
    apiClient.delete(`/teams/${teamId}/members/${userId}`),
}
